<template>
  <div class="pa-story-book-selector" ref="storyBookSelector">
    <div class="left-field">
      <button class="arrow-button arrow-button-left">
        <span>◀</span>
      </button>
    </div>
    
    <div class="swiper-field">
      <swiper :options="swiperOptions" ref="storyBookSwiper">
        <swiper-slide v-for="(item, index) in stories" :key="index">
          <StoryTitleLogo :storyData="item" />
        </swiper-slide>
      </swiper>
    </div>

    <div class="right-field">
      <button class="arrow-button arrow-button-right">
        <span>▶</span>
      </button>
    </div>
  </div>
</template>

<script>
import StoryTitleLogo from '@/components/Parts/StoryTitleLogo/StoryTitleLogo.vue'

export default {
  props : {
    stories : {
      default : () => {
        return [];
      }
    }
  },

  components : {
    StoryTitleLogo
  },

  computed : {
    swiper(){
      return this.$refs.storyBookSwiper.$swiper;
    },

    couldInitializeSwiper(){
      if(
        (this.stories.length !== 0) &&
        (this.isMountedPage === true)
      ){
        return true;
      }else{
        return false;
      }
    }
  },

  data(){
    return {
      isMountedPage : false,

      swiperOptions : {
        init          : false,
        slidesPerView : 1,
        loop          : false,
        pagination    : false,
        navigation    : {
          prevEl: '.pa-story-book-selector > .left-field > .arrow-button-left',
          nextEl: '.pa-story-book-selector > .right-field > .arrow-button-right'
        },
        on : {
          init : () => {
            this.$nextTick(() => {
              this.handleSwiperSlidechange();
            });
          },
          
          slideChange : () => {
            this.handleSwiperSlidechange();
          }
        }
      }
    };
  },

  watch : {
    couldInitializeSwiper : {
      handler(value){
        if(value === false) return;

        this.swiper.init();
      }
    }
  },

  methods : {
    handleSwiperSlidechange(){
      if(typeof this.stories === 'undefined') return;

      const currentIndex = this.swiper.activeIndex;

      if(typeof this.stories[currentIndex] !== 'undefined'){
        this.$emit('changeStory', this.stories[currentIndex]);
      }
    }
  },

  mounted(){
    this.$parent.$parent.$on('mountedPage', () => {
      this.isMountedPage = true;
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-story-book-selector{
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .left-field{
    display: flex;
    align-items: stretch;
    width:7%;
  }

  .swiper-field{
    display: flex;
    align-items: stretch;
    width:86%;

    .swiper-container{
      min-width:100%;
    }

    .pa-story-title{
      width:95%;
      margin:0 auto;
      background-color: #c2a78f;
      text-align: center;
      padding:.3rem 0;
      border-radius: 4px;
      margin-top:.4rem;
      user-select: none;

      svg{
        width:70%;
        vertical-align: middle;
      }

      @include from($desktop) {
        width:95%;

        svg{
          width:auto;
          max-width:250px;
        }
      }
    }
  }

  .right-field{
    display: flex;
    align-items: stretch;
    width:7%;
    text-align: center;
  }

  .arrow-button{
    display: flex;
    align-items: center;
    background-color: #c2a78f;
    color:#7c6961;
    border-radius: 4px;
    margin-top:.4rem;
    margin-left:.4rem;
    padding:0 .2rem;
    width:100%;
    text-align: center;
    user-select: none;
    border:0;

    span{
      text-align: center;
      width:100%;
    }

    &.swiper-button-disabled{
      color:#af9480;
    }

    &-right{
      margin-left:0;
      margin-right:.4rem;
    }
  }
}
</style>